import getTaxYear from '@/lib/helpers/getTaxYear';
import clock from '@/lib/clock';

/**
 * Return the tax years from a start year
 * @param {String|Object}
 */
const getTaxYears = (fromYear, valueKey = 'id', textKey = 'name', now = null) => {
    fromYear = fromYear || 1994;
    valueKey = valueKey || 'id';
    textKey = textKey || 'name';
    now = now || clock().clone().startOf('day');

    let currentFinancialYearStart = now.clone().month(3).date(6);

    if (currentFinancialYearStart.isAfter(now)) {
        currentFinancialYearStart = currentFinancialYearStart.subtract(1, 'year');
    }

    const currentYear = Number(currentFinancialYearStart.format('YYYY'));
    const count = currentYear - fromYear + 1;

    const years = Array.from({ length: count }, (_, i) => {
        const date = currentFinancialYearStart.clone().subtract(i, 'year');
        const taxYear = getTaxYear(date.clone());

        let startYear = taxYear[0].format('YYYY');

        let label = startYear;

        if (taxYear[1].format('YY') === '00') {
            label += '-' + taxYear[1].format('YYYY');
        } else {
            label += '-' + taxYear[1].format('YY');
        }

        if (date.isSame(currentFinancialYearStart)) {
            label += ' (Current)';
        }

        return { [valueKey]: startYear, [textKey]: label };
    });

    return years;
};

export default getTaxYears;
